<label *ngIf="label" [for]="id">
    {{label}}
    <span *ngIf="required" class="indicator-required">*</span>
    <aurora-icon *ngIf="infoText" class="info-icon" icon="information" [ngbTooltip]="infoText" container="body"></aurora-icon>
</label>
<div class="unity-form-row">
    <input type="date" 
        [id]="id"
        [name]="name"
        [value]="_value"
        [min]="_minDate"
        [max]="_maxDate"
        [disabled]="disabled"
        (change)="change($event)"
        (blur)="blur()"
    />
    <aurora-icon *ngIf="state == 'invalid'" class="status-icon" icon="error-fill"></aurora-icon>
    <aurora-icon *ngIf="state == 'warning'" class="status-icon" icon="warning-fill"></aurora-icon>
    <aurora-icon *ngIf="state == 'success'" class="status-icon" icon="checkmark"></aurora-icon>
</div>
<div *ngIf="hintText" class="message">{{hintText}}</div>